import LazyVideoComponent from "@components/LandingPageComponents/LazyVideoComponent";
import Image from "next/image";
import React from "react";

import HeroButton from "./HeroButton";

interface AiHeroSectionProps {
    botIconSrc: string;
    isCustom?: boolean;
}

const AiHeroSection: React.FC<AiHeroSectionProps> = (props) => {
    const { botIconSrc, isCustom } = props;
    return (
        <header className=" lg:px-0 px-4 lg:pt-20 pt-0 mx-auto max-w-6xl ">
            <div className="flex flex-col lg:flex-row justify-center md:justify-between pb-8">
                <div className="lg:w-3/4 gap-1 flex flex-col my-10 ">
                    {/* <div
                        className="text-blue-700 bg-blue-200 wati-top-green justify-center items-center lg:text-base font-bold  flex flex-nowrap w-fit m-auto md:m-0"
                        style={{ padding: "5px 12px", borderRadius: "50px" }}
                    >
                        <p className="lg:text-base text-xs">AI Enhanced Conversations</p>
                        <span className="wa-control-img">
                            <img loading="lazy" height="24px" width="24px" src={botIcon} className="ml-2" alt="Bot Icon" />
                        </span>
                    </div> */}
                    <span className="text-center lg:text-left mt-4">
                        {isCustom ? (
                            <h2 className=" lg:text-5xl lg:px-0 px-4 lg:leading-tight lg:pr-32 leading-normal text-3xl font-bold text-gray-700 lg:mb-6">
                                Experience 3X ROI with AI Driven WhatsApp Chatbots
                            </h2>
                        ) : (
                            <h1 className={`lg:text-5xl lg:px-0 px-4 lg:leading-tight leading-normal text-3xl font-bold text-gray-600 ${isCustom ? "mb-0" : "mb-6"} lg:mb-6`}>
                                Answer Complex Queries Easily with AI-Enhanced Responses!
                            </h1>
                        )}
                        {isCustom ? (
                            <span className="hidden md:flex md:flex-col font-bold text-2xl text-gray-500">
                                <p>✅ AI Translate</p>
                                <p>✅ AI Rewrite </p>
                                <p>✅ Natural Conversations</p>
                            </span>
                        ) : (
                            <span className="text-gray-600 lg:text-xl text-md font-normal text-center w-full pb-8">Write quickly. Communicate effectively. Make an impact.</span>
                        )}
                    </span>
                    <HeroButton buttontext="Signup for Free" />
                    <div className="flex text-gray-400 gap-4 px-2 lg:px-0 mt-4">
                        {["No setup fee", "No credit card required"].map((each) => {
                            return (
                                <div className="flex items-center gap-1 md:gap-2" key={each}>
                                    <img
                                        loading="lazy"
                                        src="https://assets.gallabox.com/gb-home/content-with-image/grey-tick-circle.svg"
                                        alt="Gray checkmark"
                                        className="opacity-50"
                                    />
                                    <p className="head-points">{each}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className={`lg:w-1/2 h-full w-full ${isCustom ? "pt-0 lg:pt-10" : "pt-10 lg:pt-24"} `}>
                    {isCustom ? (
                        <Image src={botIconSrc} alt="headerImage" height={600} width={635} />
                    ) : (
                        <LazyVideoComponent src={botIconSrc} type="video/mp4" poster="https://assets.gallabox.com/gb-home/ai/lazy-img.png" />
                    )}
                </div>
            </div>
        </header>
    );
};

export default AiHeroSection;
